import { motion } from 'framer-motion';
import heroBg from '../assets/images/hero-bg.jpg';
import AudioControl from './AudioControl';
import { useAudio } from '../contexts/AudioContext';

const Hero = () => {
  const { isPlaying, toggleAudio } = useAudio();

  const playMusic = () => {
    if (!isPlaying) {
      toggleAudio();
    }
  }

  return (
    <section
      id="Hero"
      className="relative h-screen flex items-center justify-center bg-cover bg-center"
    >
      {/* Gambar Background */}
      <img
        src={heroBg}
        alt="Wedding Background"
        className="absolute inset-0 w-full h-full object-cover"
      />

      {/* Overlay Gelap */}
      <div className="absolute inset-0 bg-black bg-opacity-50 backdrop-blur-sm"></div>

      {/* Konten Tengah */}
      <div className="relative z-10 text-center px-4">
        <motion.div
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          <h1 className="font-great-vibes text-5xl md:text-7xl text-white mb-4 drop-shadow-lg">
            Raquel & Dani
          </h1>
          <p className="text-lg md:text-2xl text-white mb-6 tracking-widest uppercase drop-shadow-md">
            Sábado 12 de Septiembre de 2026
          </p>
        </motion.div>
        <motion.div
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          <p className="text-lg md:text-2xl text-white mb-6 tracking-widest uppercase drop-shadow-md">
            ¡Nos casamos!
            <br></br>
            <motion.a href="#event-details" className="text-sm text-white">en Valencia</motion.a>
          </p>
          <p className="text-lg md:text-2xl text-white mb-6 tracking-widest uppercase drop-shadow-md">
            Y queremos que formes parte <br /> de este momento tan especial para nosotros
          </p>
        </motion.div>

        <motion.a
          href="#Couple"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.3, duration: 0.8 }}
          className="inline-block px-8 py-3 bg-rose-600 text-white rounded-full hover:bg-rose-700 transition-all shadow-xl font-semibold"
          onClick={() => playMusic()}
        >
          ¡quiero saber más!
        </motion.a>

        <motion.div
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="mt-6 px-8 py-3 text-white transition-all font-semibold"
        >
          <AudioControl />
        </motion.div>

      </div>


      {/* Panah ke Bawah */}
      <div className="absolute bottom-8 left-0 right-0 flex justify-center">
        <motion.a
          href="#Couple"
          animate={{ y: [0, 10, 0] }}
          transition={{ repeat: Infinity, duration: 2 }}
          className="text-white text-3xl drop-shadow cursor-pointer"
          onClick={() => playMusic()}
        >
          ↓
        </motion.a>
      </div>
    </section>
  );
};

export default Hero;

